import { render } from "./InputComponentPassword.vue?vue&type=template&id=3164733e"
import script from "./InputComponentPassword.vue?vue&type=script&lang=js"
export * from "./InputComponentPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__